import mondaySdk from "monday-sdk-js";

const monday = mondaySdk();

export const showNotice = (type, msg) => {
  const message = msg || "something went wrong";
  monday.execute("notice", { type: type, message, timeout: 5000 });
};

export const openLink = (url) => {
  monday.execute("openLinkInTab", { url: url });
};